var map = {
	"./ad.svg": "./app/images/country-flags/svgs/ad.svg",
	"./ae.svg": "./app/images/country-flags/svgs/ae.svg",
	"./af.svg": "./app/images/country-flags/svgs/af.svg",
	"./ag.svg": "./app/images/country-flags/svgs/ag.svg",
	"./ai.svg": "./app/images/country-flags/svgs/ai.svg",
	"./al.svg": "./app/images/country-flags/svgs/al.svg",
	"./am.svg": "./app/images/country-flags/svgs/am.svg",
	"./ao.svg": "./app/images/country-flags/svgs/ao.svg",
	"./aq.svg": "./app/images/country-flags/svgs/aq.svg",
	"./ar.svg": "./app/images/country-flags/svgs/ar.svg",
	"./as.svg": "./app/images/country-flags/svgs/as.svg",
	"./at.svg": "./app/images/country-flags/svgs/at.svg",
	"./au.svg": "./app/images/country-flags/svgs/au.svg",
	"./aw.svg": "./app/images/country-flags/svgs/aw.svg",
	"./ax.svg": "./app/images/country-flags/svgs/ax.svg",
	"./az.svg": "./app/images/country-flags/svgs/az.svg",
	"./ba.svg": "./app/images/country-flags/svgs/ba.svg",
	"./bb.svg": "./app/images/country-flags/svgs/bb.svg",
	"./bd.svg": "./app/images/country-flags/svgs/bd.svg",
	"./be.svg": "./app/images/country-flags/svgs/be.svg",
	"./bf.svg": "./app/images/country-flags/svgs/bf.svg",
	"./bg.svg": "./app/images/country-flags/svgs/bg.svg",
	"./bh.svg": "./app/images/country-flags/svgs/bh.svg",
	"./bi.svg": "./app/images/country-flags/svgs/bi.svg",
	"./bj.svg": "./app/images/country-flags/svgs/bj.svg",
	"./bl.svg": "./app/images/country-flags/svgs/bl.svg",
	"./bm.svg": "./app/images/country-flags/svgs/bm.svg",
	"./bn.svg": "./app/images/country-flags/svgs/bn.svg",
	"./bo.svg": "./app/images/country-flags/svgs/bo.svg",
	"./bq.svg": "./app/images/country-flags/svgs/bq.svg",
	"./br.svg": "./app/images/country-flags/svgs/br.svg",
	"./bs.svg": "./app/images/country-flags/svgs/bs.svg",
	"./bt.svg": "./app/images/country-flags/svgs/bt.svg",
	"./bv.svg": "./app/images/country-flags/svgs/bv.svg",
	"./bw.svg": "./app/images/country-flags/svgs/bw.svg",
	"./by.svg": "./app/images/country-flags/svgs/by.svg",
	"./bz.svg": "./app/images/country-flags/svgs/bz.svg",
	"./ca.svg": "./app/images/country-flags/svgs/ca.svg",
	"./cc.svg": "./app/images/country-flags/svgs/cc.svg",
	"./cd.svg": "./app/images/country-flags/svgs/cd.svg",
	"./cf.svg": "./app/images/country-flags/svgs/cf.svg",
	"./cg.svg": "./app/images/country-flags/svgs/cg.svg",
	"./ch.svg": "./app/images/country-flags/svgs/ch.svg",
	"./ci.svg": "./app/images/country-flags/svgs/ci.svg",
	"./ck.svg": "./app/images/country-flags/svgs/ck.svg",
	"./cl.svg": "./app/images/country-flags/svgs/cl.svg",
	"./cm.svg": "./app/images/country-flags/svgs/cm.svg",
	"./cn.svg": "./app/images/country-flags/svgs/cn.svg",
	"./co.svg": "./app/images/country-flags/svgs/co.svg",
	"./cr.svg": "./app/images/country-flags/svgs/cr.svg",
	"./cu.svg": "./app/images/country-flags/svgs/cu.svg",
	"./cv.svg": "./app/images/country-flags/svgs/cv.svg",
	"./cw.svg": "./app/images/country-flags/svgs/cw.svg",
	"./cx.svg": "./app/images/country-flags/svgs/cx.svg",
	"./cy.svg": "./app/images/country-flags/svgs/cy.svg",
	"./cz.svg": "./app/images/country-flags/svgs/cz.svg",
	"./de.svg": "./app/images/country-flags/svgs/de.svg",
	"./dj.svg": "./app/images/country-flags/svgs/dj.svg",
	"./dk.svg": "./app/images/country-flags/svgs/dk.svg",
	"./dm.svg": "./app/images/country-flags/svgs/dm.svg",
	"./do.svg": "./app/images/country-flags/svgs/do.svg",
	"./dz.svg": "./app/images/country-flags/svgs/dz.svg",
	"./ec.svg": "./app/images/country-flags/svgs/ec.svg",
	"./ee.svg": "./app/images/country-flags/svgs/ee.svg",
	"./eg.svg": "./app/images/country-flags/svgs/eg.svg",
	"./eh.svg": "./app/images/country-flags/svgs/eh.svg",
	"./er.svg": "./app/images/country-flags/svgs/er.svg",
	"./es-ca.svg": "./app/images/country-flags/svgs/es-ca.svg",
	"./es.svg": "./app/images/country-flags/svgs/es.svg",
	"./et.svg": "./app/images/country-flags/svgs/et.svg",
	"./eu.svg": "./app/images/country-flags/svgs/eu.svg",
	"./fi.svg": "./app/images/country-flags/svgs/fi.svg",
	"./fj.svg": "./app/images/country-flags/svgs/fj.svg",
	"./fk.svg": "./app/images/country-flags/svgs/fk.svg",
	"./fm.svg": "./app/images/country-flags/svgs/fm.svg",
	"./fo.svg": "./app/images/country-flags/svgs/fo.svg",
	"./fr.svg": "./app/images/country-flags/svgs/fr.svg",
	"./ga.svg": "./app/images/country-flags/svgs/ga.svg",
	"./gb-eng.svg": "./app/images/country-flags/svgs/gb-eng.svg",
	"./gb-nir.svg": "./app/images/country-flags/svgs/gb-nir.svg",
	"./gb-sct.svg": "./app/images/country-flags/svgs/gb-sct.svg",
	"./gb-wls.svg": "./app/images/country-flags/svgs/gb-wls.svg",
	"./gb.svg": "./app/images/country-flags/svgs/gb.svg",
	"./gd.svg": "./app/images/country-flags/svgs/gd.svg",
	"./ge.svg": "./app/images/country-flags/svgs/ge.svg",
	"./gf.svg": "./app/images/country-flags/svgs/gf.svg",
	"./gg.svg": "./app/images/country-flags/svgs/gg.svg",
	"./gh.svg": "./app/images/country-flags/svgs/gh.svg",
	"./gi.svg": "./app/images/country-flags/svgs/gi.svg",
	"./gl.svg": "./app/images/country-flags/svgs/gl.svg",
	"./gm.svg": "./app/images/country-flags/svgs/gm.svg",
	"./gn.svg": "./app/images/country-flags/svgs/gn.svg",
	"./gp.svg": "./app/images/country-flags/svgs/gp.svg",
	"./gq.svg": "./app/images/country-flags/svgs/gq.svg",
	"./gr.svg": "./app/images/country-flags/svgs/gr.svg",
	"./gs.svg": "./app/images/country-flags/svgs/gs.svg",
	"./gt.svg": "./app/images/country-flags/svgs/gt.svg",
	"./gu.svg": "./app/images/country-flags/svgs/gu.svg",
	"./gw.svg": "./app/images/country-flags/svgs/gw.svg",
	"./gy.svg": "./app/images/country-flags/svgs/gy.svg",
	"./hk.svg": "./app/images/country-flags/svgs/hk.svg",
	"./hm.svg": "./app/images/country-flags/svgs/hm.svg",
	"./hn.svg": "./app/images/country-flags/svgs/hn.svg",
	"./hr.svg": "./app/images/country-flags/svgs/hr.svg",
	"./ht.svg": "./app/images/country-flags/svgs/ht.svg",
	"./hu.svg": "./app/images/country-flags/svgs/hu.svg",
	"./id.svg": "./app/images/country-flags/svgs/id.svg",
	"./ie.svg": "./app/images/country-flags/svgs/ie.svg",
	"./il.svg": "./app/images/country-flags/svgs/il.svg",
	"./im.svg": "./app/images/country-flags/svgs/im.svg",
	"./in.svg": "./app/images/country-flags/svgs/in.svg",
	"./io.svg": "./app/images/country-flags/svgs/io.svg",
	"./iq.svg": "./app/images/country-flags/svgs/iq.svg",
	"./ir.svg": "./app/images/country-flags/svgs/ir.svg",
	"./is.svg": "./app/images/country-flags/svgs/is.svg",
	"./it.svg": "./app/images/country-flags/svgs/it.svg",
	"./je.svg": "./app/images/country-flags/svgs/je.svg",
	"./jm.svg": "./app/images/country-flags/svgs/jm.svg",
	"./jo.svg": "./app/images/country-flags/svgs/jo.svg",
	"./jp.svg": "./app/images/country-flags/svgs/jp.svg",
	"./ke.svg": "./app/images/country-flags/svgs/ke.svg",
	"./kg.svg": "./app/images/country-flags/svgs/kg.svg",
	"./kh.svg": "./app/images/country-flags/svgs/kh.svg",
	"./ki.svg": "./app/images/country-flags/svgs/ki.svg",
	"./km.svg": "./app/images/country-flags/svgs/km.svg",
	"./kn.svg": "./app/images/country-flags/svgs/kn.svg",
	"./kp.svg": "./app/images/country-flags/svgs/kp.svg",
	"./kr.svg": "./app/images/country-flags/svgs/kr.svg",
	"./kw.svg": "./app/images/country-flags/svgs/kw.svg",
	"./ky.svg": "./app/images/country-flags/svgs/ky.svg",
	"./kz.svg": "./app/images/country-flags/svgs/kz.svg",
	"./la.svg": "./app/images/country-flags/svgs/la.svg",
	"./lb.svg": "./app/images/country-flags/svgs/lb.svg",
	"./lc.svg": "./app/images/country-flags/svgs/lc.svg",
	"./li.svg": "./app/images/country-flags/svgs/li.svg",
	"./lk.svg": "./app/images/country-flags/svgs/lk.svg",
	"./lr.svg": "./app/images/country-flags/svgs/lr.svg",
	"./ls.svg": "./app/images/country-flags/svgs/ls.svg",
	"./lt.svg": "./app/images/country-flags/svgs/lt.svg",
	"./lu.svg": "./app/images/country-flags/svgs/lu.svg",
	"./lv.svg": "./app/images/country-flags/svgs/lv.svg",
	"./ly.svg": "./app/images/country-flags/svgs/ly.svg",
	"./ma.svg": "./app/images/country-flags/svgs/ma.svg",
	"./mc.svg": "./app/images/country-flags/svgs/mc.svg",
	"./md.svg": "./app/images/country-flags/svgs/md.svg",
	"./me.svg": "./app/images/country-flags/svgs/me.svg",
	"./mf.svg": "./app/images/country-flags/svgs/mf.svg",
	"./mg.svg": "./app/images/country-flags/svgs/mg.svg",
	"./mh.svg": "./app/images/country-flags/svgs/mh.svg",
	"./mk.svg": "./app/images/country-flags/svgs/mk.svg",
	"./ml.svg": "./app/images/country-flags/svgs/ml.svg",
	"./mm.svg": "./app/images/country-flags/svgs/mm.svg",
	"./mn.svg": "./app/images/country-flags/svgs/mn.svg",
	"./mo.svg": "./app/images/country-flags/svgs/mo.svg",
	"./mp.svg": "./app/images/country-flags/svgs/mp.svg",
	"./mq.svg": "./app/images/country-flags/svgs/mq.svg",
	"./mr.svg": "./app/images/country-flags/svgs/mr.svg",
	"./ms.svg": "./app/images/country-flags/svgs/ms.svg",
	"./mt.svg": "./app/images/country-flags/svgs/mt.svg",
	"./mu.svg": "./app/images/country-flags/svgs/mu.svg",
	"./mv.svg": "./app/images/country-flags/svgs/mv.svg",
	"./mw.svg": "./app/images/country-flags/svgs/mw.svg",
	"./mx.svg": "./app/images/country-flags/svgs/mx.svg",
	"./my.svg": "./app/images/country-flags/svgs/my.svg",
	"./mz.svg": "./app/images/country-flags/svgs/mz.svg",
	"./na.svg": "./app/images/country-flags/svgs/na.svg",
	"./nc.svg": "./app/images/country-flags/svgs/nc.svg",
	"./ne.svg": "./app/images/country-flags/svgs/ne.svg",
	"./nf.svg": "./app/images/country-flags/svgs/nf.svg",
	"./ng.svg": "./app/images/country-flags/svgs/ng.svg",
	"./ni.svg": "./app/images/country-flags/svgs/ni.svg",
	"./nl.svg": "./app/images/country-flags/svgs/nl.svg",
	"./no.svg": "./app/images/country-flags/svgs/no.svg",
	"./np.svg": "./app/images/country-flags/svgs/np.svg",
	"./nr.svg": "./app/images/country-flags/svgs/nr.svg",
	"./nu.svg": "./app/images/country-flags/svgs/nu.svg",
	"./nz.svg": "./app/images/country-flags/svgs/nz.svg",
	"./om.svg": "./app/images/country-flags/svgs/om.svg",
	"./pa.svg": "./app/images/country-flags/svgs/pa.svg",
	"./pe.svg": "./app/images/country-flags/svgs/pe.svg",
	"./pf.svg": "./app/images/country-flags/svgs/pf.svg",
	"./pg.svg": "./app/images/country-flags/svgs/pg.svg",
	"./ph.svg": "./app/images/country-flags/svgs/ph.svg",
	"./pk.svg": "./app/images/country-flags/svgs/pk.svg",
	"./pl.svg": "./app/images/country-flags/svgs/pl.svg",
	"./pm.svg": "./app/images/country-flags/svgs/pm.svg",
	"./pn.svg": "./app/images/country-flags/svgs/pn.svg",
	"./pr.svg": "./app/images/country-flags/svgs/pr.svg",
	"./ps.svg": "./app/images/country-flags/svgs/ps.svg",
	"./pt.svg": "./app/images/country-flags/svgs/pt.svg",
	"./pw.svg": "./app/images/country-flags/svgs/pw.svg",
	"./py.svg": "./app/images/country-flags/svgs/py.svg",
	"./qa.svg": "./app/images/country-flags/svgs/qa.svg",
	"./re.svg": "./app/images/country-flags/svgs/re.svg",
	"./ro.svg": "./app/images/country-flags/svgs/ro.svg",
	"./rs.svg": "./app/images/country-flags/svgs/rs.svg",
	"./ru.svg": "./app/images/country-flags/svgs/ru.svg",
	"./rw.svg": "./app/images/country-flags/svgs/rw.svg",
	"./sa.svg": "./app/images/country-flags/svgs/sa.svg",
	"./sb.svg": "./app/images/country-flags/svgs/sb.svg",
	"./sc.svg": "./app/images/country-flags/svgs/sc.svg",
	"./sd.svg": "./app/images/country-flags/svgs/sd.svg",
	"./se.svg": "./app/images/country-flags/svgs/se.svg",
	"./sg.svg": "./app/images/country-flags/svgs/sg.svg",
	"./sh.svg": "./app/images/country-flags/svgs/sh.svg",
	"./si.svg": "./app/images/country-flags/svgs/si.svg",
	"./sj.svg": "./app/images/country-flags/svgs/sj.svg",
	"./sk.svg": "./app/images/country-flags/svgs/sk.svg",
	"./sl.svg": "./app/images/country-flags/svgs/sl.svg",
	"./sm.svg": "./app/images/country-flags/svgs/sm.svg",
	"./sn.svg": "./app/images/country-flags/svgs/sn.svg",
	"./so.svg": "./app/images/country-flags/svgs/so.svg",
	"./sr.svg": "./app/images/country-flags/svgs/sr.svg",
	"./ss.svg": "./app/images/country-flags/svgs/ss.svg",
	"./st.svg": "./app/images/country-flags/svgs/st.svg",
	"./sv.svg": "./app/images/country-flags/svgs/sv.svg",
	"./sx.svg": "./app/images/country-flags/svgs/sx.svg",
	"./sy.svg": "./app/images/country-flags/svgs/sy.svg",
	"./sz.svg": "./app/images/country-flags/svgs/sz.svg",
	"./tc.svg": "./app/images/country-flags/svgs/tc.svg",
	"./td.svg": "./app/images/country-flags/svgs/td.svg",
	"./tf.svg": "./app/images/country-flags/svgs/tf.svg",
	"./tg.svg": "./app/images/country-flags/svgs/tg.svg",
	"./th.svg": "./app/images/country-flags/svgs/th.svg",
	"./tj.svg": "./app/images/country-flags/svgs/tj.svg",
	"./tk.svg": "./app/images/country-flags/svgs/tk.svg",
	"./tl.svg": "./app/images/country-flags/svgs/tl.svg",
	"./tm.svg": "./app/images/country-flags/svgs/tm.svg",
	"./tn.svg": "./app/images/country-flags/svgs/tn.svg",
	"./to.svg": "./app/images/country-flags/svgs/to.svg",
	"./tr.svg": "./app/images/country-flags/svgs/tr.svg",
	"./tt.svg": "./app/images/country-flags/svgs/tt.svg",
	"./tv.svg": "./app/images/country-flags/svgs/tv.svg",
	"./tw.svg": "./app/images/country-flags/svgs/tw.svg",
	"./tz.svg": "./app/images/country-flags/svgs/tz.svg",
	"./ua.svg": "./app/images/country-flags/svgs/ua.svg",
	"./ug.svg": "./app/images/country-flags/svgs/ug.svg",
	"./um.svg": "./app/images/country-flags/svgs/um.svg",
	"./un.svg": "./app/images/country-flags/svgs/un.svg",
	"./us.svg": "./app/images/country-flags/svgs/us.svg",
	"./uy.svg": "./app/images/country-flags/svgs/uy.svg",
	"./uz.svg": "./app/images/country-flags/svgs/uz.svg",
	"./va.svg": "./app/images/country-flags/svgs/va.svg",
	"./vc.svg": "./app/images/country-flags/svgs/vc.svg",
	"./ve.svg": "./app/images/country-flags/svgs/ve.svg",
	"./vg.svg": "./app/images/country-flags/svgs/vg.svg",
	"./vi.svg": "./app/images/country-flags/svgs/vi.svg",
	"./vn.svg": "./app/images/country-flags/svgs/vn.svg",
	"./vu.svg": "./app/images/country-flags/svgs/vu.svg",
	"./wf.svg": "./app/images/country-flags/svgs/wf.svg",
	"./ws.svg": "./app/images/country-flags/svgs/ws.svg",
	"./xk.svg": "./app/images/country-flags/svgs/xk.svg",
	"./ye.svg": "./app/images/country-flags/svgs/ye.svg",
	"./yt.svg": "./app/images/country-flags/svgs/yt.svg",
	"./za.svg": "./app/images/country-flags/svgs/za.svg",
	"./zm.svg": "./app/images/country-flags/svgs/zm.svg",
	"./zw.svg": "./app/images/country-flags/svgs/zw.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/images/country-flags/svgs sync recursive .svg$";